export var DEPLOY_DATE = new Date('2026-07-24T11:13:50+0000');
